import React from "react";
import { Download, Loader2 } from "lucide-react";
import { Button } from "../../components/ui/button";

/** PDF is the only export, so there is nothing to choose between. */
export default function AgentExportPicker({ onExport, busy = false }) {
  return (
    <Button
      type="button"
      variant="outline"
      onClick={onExport}
      disabled={busy}
      aria-busy={busy}
      title="Export PDF"
    >
      {busy ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <Download className="h-4 w-4" />
      )}
      {busy ? "Exporting" : "Export PDF"}
    </Button>
  );
}
